import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AssessmentUpdateInput } from '../generated/globalTypes';
import { updateAssessmentMutation, updateAssessmentMutationVariables } from '../generated/updateAssessmentMutation';
import { assessmentFieldsFragment } from '../models/Assessment';

/**
 * Get a callback to update a Assessment in the store.
 */
export function useUpdateAssessmentCallback(): [(id: string, model: AssessmentUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateAssessmentMutation, updateAssessmentMutationVariables>(
        gql`
            mutation updateAssessmentMutation ($model: AssessmentUpdateInput!) {
                updateAssessment(model: $model) {
                    ...assessmentFields
                }
            }

            ${assessmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: AssessmentUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
